import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { RichText } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { Item } from '../PracticalInformation/Item'

export function SkiLessons() {
  const ski = useCMSPageField('PDP.SkiAncillaries')
  const intl = useIntl()

  const introduction = ski?.skiLessons?.introduction
  const extraInfo = ski?.skiLessons?.extraInfo

  if (!introduction && !extraInfo)
    return null

  return (
    <Item elementDL="Ski lessons" title={intl.formatMessage({ id: 'ski_ancillaries_ski_lessons_title' })} Glyph="PersonSkiing">
      {introduction && <RichText innerHTML={introduction} />}
      {extraInfo && <RichText innerHTML={extraInfo} />}
    </Item>
  )
}
